/* PDP Tabs 2026 — desktop tab switcher + mobile accordion (no jQuery).
   Desktop visibility is driven by `.is-active`, mobile by `.is-open`, so the
   two modes never fight when the viewport changes.
   FAQ items use native <details>, so they need no JS. */
(function () {
  'use strict';

  class PdpTabs2026 extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.pdp-tabs-2026__tab'));
      this.panels = Array.from(this.querySelectorAll('.pdp-tabs-2026__panel'));
      this.accHeaders = Array.from(this.querySelectorAll('.pdp-tabs-2026__acc-header'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab));
        tab.addEventListener('keydown', (e) => this.onKeydown(e));
      });

      this.accHeaders.forEach((header) => {
        header.addEventListener('click', () => this.toggle(header));
      });
    }

    /* Desktop tabs */
    activate(tab) {
      const id = tab.getAttribute('data-tab');

      this.tabs.forEach((t) => {
        const active = t === tab;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.tabIndex = active ? 0 : -1;
      });

      this.panels.forEach((p) => {
        p.classList.toggle('is-active', p.getAttribute('data-panel') === id);
      });

      this.setAttribute('data-active-panel', id);
    }

    onKeydown(e) {
      const idx = this.tabs.indexOf(e.target);
      if (idx === -1) return;
      let next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = this.tabs[idx + 1] || this.tabs[0];
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = this.tabs[idx - 1] || this.tabs[this.tabs.length - 1];
      else if (e.key === 'Home') next = this.tabs[0];
      else if (e.key === 'End') next = this.tabs[this.tabs.length - 1];
      if (next) {
        e.preventDefault();
        this.activate(next);
        next.focus();
      }
    }

    /* Mobile accordion: one panel open at a time; tapping the open header closes it. */
    toggle(header) {
      const id = header.getAttribute('data-acc');
      const wasOpen = header.classList.contains('is-open');

      this.accHeaders.forEach((h) => {
        const open = h === header && !wasOpen;
        h.classList.toggle('is-open', open);
        h.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      this.panels.forEach((p) => {
        p.classList.toggle('is-open', p.getAttribute('data-panel') === id && !wasOpen);
      });
    }
  }

  if (!customElements.get('pdp-tabs-2026')) {
    customElements.define('pdp-tabs-2026', PdpTabs2026);
  }
})();
